export default __webpack_public_path__ + "static/media/Banner1.eb742ff1.png";